import { Inject, Injectable } from '@angular/core';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root',
})

export class NewsService {
  private readonly newsBaseApiUrl: string;


  constructor(@Inject('BASE_URL') baseUrl: string, private dataService: DataService) {
    this.newsBaseApiUrl = `${baseUrl}api/news`;
  }

  public getNews(industry: string) {
    let newsApiUrl = `${this.newsBaseApiUrl}/${industry}`;

    return this.dataService.get<any>(newsApiUrl);
  }

  public downloadFile(container, fileName, id) {
    let fileApiUrl = `${this.newsBaseApiUrl}/files/${container}/${btoa(fileName)}/${id}`;

    return this.dataService.getFile(fileApiUrl);
  }
}
